/*       */

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Switch, Route } from 'react-router-dom';

import LlmProvidersMain from 'app/containers/Admin/Settings/Ai/LlmProvidersMain';

/**
 * Defines the routes for the LLM Providers views (Security → AI).
 */
class LlmProvidersRoute extends PureComponent {
    static propTypes = {
        match: PropTypes.object.isRequired,
    };

    render() {
        const { match } = this.props;
        return (
            <Switch>
                <Route path={`${match.url}`} exact component={LlmProvidersMain} />
            </Switch>
        );
    }
}

export default LlmProvidersRoute;
